import React from 'react';

const rows = [
  { crit: 'Monthly cost', sy: 'from $297/month', hu: '$2,000 – $4,000/month' },
  { crit: 'Availability', sy: '24/7', hu: 'Office hours' },
  { crit: 'Response time', sy: <>&lt; 1 minute</>, hu: '30 min to several hours' },
  { crit: 'Simultaneous conversations', sy: 'unlimited', hu: '5 to 10 max' },
  { crit: 'Channels handled in parallel', sy: '10, centralized', hu: '1 or 2' },
  { crit: 'Consistency', sy: '100% constant', hu: 'Varies with fatigue' }
];

function Comparison() {
  return (
    <section id="vs" style={{ paddingTop: 0 }}>
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow">Salesyo vs human team</div>
          <h2>A salesperson's work. Without the fatigue, or the salary.</h2>
          <p>Salesyo doesn't replace your closers. It hands them conversations that are already warm.</p>
        </div>
        <div className="vs">
          <div className="vs-row head">
            <div className="crit">Criteria</div>
            <div className="sy">Salesyo</div>
            <div className="hu">Human salesperson / setter</div>
          </div>
          {rows.map((r, i) => (
            <div className="vs-row" key={i}>
              <div className="crit">{r.crit}</div>
              <div className="sy">{r.sy}</div>
              <div className="hu">{r.hu}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Comparison;
